import Linkify from 'react-linkify'
import { NO_BREAK_SPACE, StringUtils } from 'src/utils/string'
import { PostTextProps } from './postText.types'
import { Wrapper } from './postText.styles'

const PostText = ({ description, className }: PostTextProps) => {
  return (
    <Wrapper className={className}>
      <Linkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <a target="blank" href={decoratedHref} key={key}>
            {decoratedText}
          </a>
        )}
      >
        {StringUtils.replaceCharacterGloballyByKey(description ?? '', NO_BREAK_SPACE, ' ')}
      </Linkify>
    </Wrapper>
  )
}

export default PostText
